import * as React from 'react';
import InfoButton from '../info-button/InfoButton';
import {
  BasicSectionContainer,
  HeaderText,
  Content,
  MarginContainer,
} from './BasicContentSection.style';

const BasicContentSection = ({ section, noButton, days }) => {
  const {
    document: {
      data: {
        section_title: sectionTitle,
        section_description: sectionDescription,
        button_link: buttonLink,
        button_text: buttonText,
      },
    },
  } = section;

  return (
    <MarginContainer>
      <BasicSectionContainer>
        <HeaderText>
          {days && days} {sectionTitle.text}
        </HeaderText>
        <Content>{sectionDescription.text}</Content>
        {!noButton && (
          <InfoButton
            buttonLink={buttonLink.url}
            buttonText={buttonText.text}
          />
        )}
      </BasicSectionContainer>
    </MarginContainer>
  );
};

export default BasicContentSection;
